import { Component, OnInit, EventEmitter, Input, HostListener, ViewChild, ElementRef, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
})
export class TimeInputComponent implements OnInit {
  showPlaceholder: boolean;
  @Input() placeholder: string;

  hourValue: number = undefined;
  @Input()
  get hour() {
    return this.hourValue;
  }
  set hour(val) {
    this.hourValue = val;
    this.hourChange.emit(this.hourValue);
  }
  @Output() hourChange = new EventEmitter();

  minuteValue: number = undefined;
  @Input()
  get minute() {
    return this.minuteValue;
  }
  set minute(val) {
    this.minuteValue = val;
    this.minuteChange.emit(this.minuteValue);
  }
  @Output() minuteChange = new EventEmitter();

  @Input() class: string = 'null';
  classes() {
    const classes = {};
    classes['showPlaceholder'] = this.showPlaceholder;
    classes[this.class] = true;
    return classes;
  }

  @ViewChild('inputHour') inputHour: ElementRef;
  @ViewChild('inputMinute') inputMinute: ElementRef;

  constructor() {}

  public reset() {
    this.showPlaceholder = true;
    this.inputHour.nativeElement.value = '';
    this.inputMinute.nativeElement.value = '';
    this.minuteValue = undefined;
    this.hourValue = undefined;
  }

  filteredOptions: Observable<string[]>;

  ngOnInit() {
    if (this.hourValue != undefined) {
      this.inputHour.nativeElement.value = this.hour.toString();
      this.blurHour();
    }

    if (this.minuteValue != undefined) {
      this.inputMinute.nativeElement.value = this.minute.toString();
      this.blurMinute();
    }

    if (!this.inputHour.nativeElement.value && !this.inputMinute.nativeElement.val) {
      this.showPlaceholder = true;
    }
  }

  focused() {
    if (this.showPlaceholder) {
      this.inputHour.nativeElement.click();
      this.inputHour.nativeElement.focus();
      this.showPlaceholder = false;
    }
  }

  blurHour() {
    if (this.hourValue < 10) {
      this.inputHour.nativeElement.value = '0' + this.hourValue;
    }
  }

  blurMinute() {
    if (this.minuteValue < 10) {
      this.inputMinute.nativeElement.value = '0' + this.minuteValue;
    }
  }

  @HostListener('document:keyup', ['$event'])
  keyUp(event: KeyboardEvent) {
    if (this.inputHour.nativeElement === document.activeElement) {
      this.evaluateHour(this.inputHour.nativeElement.value);
      this.showPlaceholder = false;
    } else if (this.inputMinute.nativeElement === document.activeElement) {
      /**
      * Focus Hour Input when Backspace on empty Minute
      */
      if (event.key === 'Backspace' && this.minute === undefined) {
        this.inputHour.nativeElement.focus();
      }
      this.evaluateMinute(this.inputMinute.nativeElement.value);
      this.showPlaceholder = false;
    }
  }

  evaluateHour(text: string) {
    if (Number(text) === this.hour) {
      return;
    }

    if (text === '') {
      this.inputHour.nativeElement.value = '';
      return;
    }

    const num = Number(text);
    if (isNaN(num)) {
      this.inputHour.nativeElement.value = this.hour || '';
      return;
    } else {
      if (num < 10 && num > 0) {
        this.hour = Math.floor(num);
      } else if (num >= 0 && num < 24) {
        this.hour = Math.floor(num);
      }

      this.inputHour.nativeElement.value = this.hour;
    }

    /**
     * Autofocus Minute Input when Hour Input is finished
     */
    if (this.inputHour.nativeElement.value.length === 2) {
      this.inputMinute.nativeElement.focus();
    }
  }

  evaluateMinute(text: string) {
    if (Number(text) === this.minute) {
      return;
    }

    if (text === '') {
      this.inputMinute.nativeElement.value = '';
      this.minute = undefined;
      return;
    }

    const num = Number(text);
    if (isNaN(num)) {
      this.inputMinute.nativeElement.value = this.minute || '';
      return;
    } else {
      if (num < 10 && num > 0) {
        this.minute = Math.floor(num);
      } else if (num >= 0 && num < 60) {
        this.minute = Math.floor(num);
      }

      this.inputMinute.nativeElement.value = this.minute;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/time-input/time-input.component.ts